/** 投标总览 — 钢蓝运营色 */
export const BLUE = {
  primary: '#1f6feb',
  dark: '#0f3d73',
  mid: '#3d8ee8',
  light: '#6eb0f5',
  pale: '#dcecff',
  bg: '#f3f8ff',
  border: '#d7e2ef',
  text: '#15263d',
  muted: '#6a7f99',
};

export const AMBER = {
  primary: '#c9780c',
  dark: '#92400e',
  mid: '#e09b2d',
  light: '#f0d08a',
  pale: '#fff3d9',
  bg: '#fff8eb',
  border: '#f6e2b8',
};

export const LIST_SIZE = 10;
export const LIST_COLS = 1;
export const FEED_SIZE = 7;
export const ACTIVITY_SIZE = 10;

export const CHART_COLORS = [
  '#1f6feb', '#c9780c', '#0f3d73', '#3d8ee8', '#6a7f99', '#e09b2d',
];

export const MODULE_THEME = {
  info: {accent: BLUE.primary, accentBg: BLUE.pale, icon: 'md-analytics'},
  work: {accent: BLUE.dark, accentBg: BLUE.bg, icon: 'md-hammer'},
  open: {accent: AMBER.primary, accentBg: AMBER.pale, icon: 'md-clipboard'},
};

export function chartColor(index) {
  return CHART_COLORS[index % CHART_COLORS.length];
}
